import type { MetaCampaignOverviewRow } from '@/lib/types';
import { toDisplayAmount } from './money';
import type { Platform } from './types';

export interface PerfAlert {
  severity: 'warning' | 'critical';
  message: string;
  campaign?: string;
  platform?: Platform;
}

/**
 * Client-side Meta alert rules (09-08), mirroring the Google set where the
 * synced snapshot supports them: meaningful spend with zero leads, and
 * creative-fatigue frequency. Same spend threshold as the Google
 * spend-without-conversions rule.
 */
export function computeMetaAlerts(rows: MetaCampaignOverviewRow[], cs: string): PerfAlert[] {
  const alerts: PerfAlert[] = [];
  for (const row of rows) {
    const spend = toDisplayAmount(row.spend_cents, 'meta');
    const name = row.name || row.meta_campaign_id;
    if (spend > 50 && row.leads === 0) {
      alerts.push({
        severity: 'critical',
        platform: 'meta',
        campaign: name,
        message: `${cs}${spend.toFixed(0)} spent with no leads`,
      });
    }
    const frequency = parseFloat(row.frequency ?? '0');
    if (frequency >= 4) {
      alerts.push({
        severity: 'warning',
        platform: 'meta',
        campaign: name,
        message: `Frequency ${frequency.toFixed(1)}, creative fatigue risk`,
      });
    }
  }
  return alerts;
}
